/*eslint-disable*/
import React, { useEffect, useState } from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
// @material-ui/icons
import { Apps, School, Home, Book, Work } from "@material-ui/icons";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import BeatLoader from "react-spinners/BeatLoader";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";
import Axios from "axios";
import Config from "../../config.js"

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";
import { getDisplayDate } from "@material-ui/pickers/_helpers/text-field-helper";
const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  let [wink, setWink] = useState(false);
  let [list, setList] = useState([
    <BeatLoader color={"gray"} size={15} />,
  ]);

  var Update = () => {
    var op = (data) => {
      var l = [];
      if (data.length == 0) {
        setWink(false);
      }
      else {
        setWink(true)
        var array = JSON.parse(JSON.stringify(data));
        for (var i = 0; i < array.length; i++) {
          var element = array[i]
          l.push(<Button
            target="_blank"
            href={element.subLink}
            color="transparent"
            className={classes.navLink}
          >
            {element.subLinkTitle ? element.subLinkTitle : element.title}
          </Button>)
        }
      }
      if (l.length == 0) {
        setList([<Button
          color="transparent"
          className={classes.navLink}
        >
          موردی فعال نیست.
        </Button>])

      } else
        setList(l)
    }
    var p = JSON.parse(localStorage.getItem('init'));
    var now = Date.now();
    var min = 15;
    if (p && now - p.setupDate < min * 60 * 1000) {
      var data = p.data
      op(data)
    } else {

      var param = {
        withSubLink: true,
      };
      Axios.post(Config.api + "Now/GetAll", param,
        {
          headers: {
            apikey: Config.apikey
          }
        }).then((result) => {
          var data = result.data.data;
          var p = {
            data: data,
            setupDate: Date.now()
          }
          localStorage.setItem('init', JSON.stringify(p));
          op(data)

        }).catch(err => {
          console.log(err)
        })
    }
  }
  useEffect(() => {
    Update();
  }, [])
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          href="/"
          color="transparent"
          className={classes.navLink}
        >
          <Home className={classes.icons} /> خانه
        </Button>
      </ListItem>
      <ListItem className={classes.listItem} >
        <Button
          href="/Courses"
          color="transparent"
          className={classes.navLink}
        >
          <School className={classes.icons} /> آموزش
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="رویداد"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Apps}
          dropdownList={[
            <a
            target="_blank"
            href="https://itnext.sharifcamp.ir"
            rel="noopener noreferrer"
            className={classes.dropdownLink}
          >
            رویداد تجربه‌محور نگاهی به آینده فناوری اطلاعات (ITNext)
          </a>,
            <Link to="/SOPC" className={classes.dropdownLink}>
              مسابقات کد نویسی مبهم (SOPC)
            </Link>,
            <Link to="/TopDev" className={classes.dropdownLink}>
              مسابقات برنامه نویسی آنلاین (TopDev)
            </Link>,
            <Link to="/RoboCupSoccerSimulation" className={classes.dropdownLink}>
              مسابقه شبیه سازی رایانه ای فوتبال
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="خدمات"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/Services/Tour" className={classes.dropdownLink}>
              نمایشگاه مجازی ترنج
            </Link>,
            <Link to="/Services/PenetrationTesting" className={classes.dropdownLink}>
              مشاوره و تست امنیت
            </Link>,

            /*<Link to="/Services/TechnicalAdvice" className={classes.dropdownLink}>
              مشاوره های فنی و مدیریتی
            </Link>,
            <Link to="/Services/ContentProvide" className={classes.dropdownLink}>
              تولید محتوا وبسایت و شبکه های اجتماعی
            </Link>,
            <Link to="/Services/Design" className={classes.dropdownLink}>
              طراحی رابط کاربری و لوگو
            </Link>,*/



          ]}
        />
      </ListItem>




      {wink
        ?
        <ListItem className={classes.listItem} >
          <CustomDropdown
            noLiPadding
            buttonText="رویداد فعال"
            buttonProps={{
              className: classes.navLink,
              color: "transparent"
            }}
            buttonIcon={() => {
              if (wink)
                return (<FiberManualRecordIcon className={classes.wink} color="secondary" />)
              else return <FiberManualRecordIcon />
            }}
            dropdownList={list}
          />
        </ListItem>

        : ""
      }


      {/*<ListItem className={classes.listItem}>
        <Button
          target="_blank"
          href="http://blog.sharifcamp.ir"
          color="transparent"
          className={classes.navLink}
        >
          <Book className={classes.icons} /> بلاگ
        </Button>
      </ListItem>
      */
      }
      <ListItem className={classes.listItem}>
        {/*<Tooltip title="Delete">
          <IconButton aria-label="Delete">
            <DeleteIcon />
          </IconButton>
        </Tooltip>*/}
        <Tooltip
          id="telegram-tooltip"
          title="در تلگرام با ما در ارتباط باشید"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href="https://telegram.me/sharifcamp"
            target="_blank"
            color="transparent"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-telegram"} />
          </Button>
        </Tooltip>
      </ListItem>
      {/*<ListItem className={classes.listItem}>
        <Tooltip
          id="youtube-tooltip"
          title="با ما در یوتیوب همراه باشید"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href="https://www.youtube.com/channel/UC-W19_l8bzN9caiz-UThQ4w/"
            target="_blank"
            color="transparent"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-youtube"} />
          </Button>
        </Tooltip>
      </ListItem>
      */}
      <ListItem className={classes.listItem}>
        <Tooltip
          id="linkedin-tooltip"
          title="از لینکدین ما دیدن کنید"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.linkedin.com/company/sharifcamp/"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-linkedin"} />
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title="ما را در اینستاگرام دنبال کنید"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.instagram.com/sharifcamp"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-instagram"} />
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}
